module.exports = __webpack_public_path__ + "img/map-point.f7e13ec3.svg";